import { CreditRisk } from '@types';
import { moneyFormatter } from '@utils';
import cls from './FinancialRatios.module.css';


interface Props {
  risk: CreditRisk;
  title?: string;
}

export interface FinancialTableValue {
  key: string;
  title: string;
  value: number;
  percent?: number;
}

interface TableProps {
  rows: FinancialTableValue[];
  onlyMoney?: boolean;
}

const Table = ({ rows, onlyMoney }: TableProps) => {
  const getVal = (r: FinancialTableValue) => {
    if (onlyMoney) {
      return moneyFormatter.format(r.value);
    }
    if (r.key === 'dscr') {
      return r.value ? `${r.value}x` : 0;
    }
    if (r.percent) return `${r.value}%`;

    return r.value;
  };

  return (
    <div className={cls.table}>
      {rows.map((i: FinancialTableValue, idx: number) => (
        <div className={cls.line} key={idx}>
          <div className={cls.label}>{i.title}</div>
          <div className={cls.value}>{getVal(i)}</div>
        </div>))}
    </div>
  );
};

export const FinancialRatios = ({ risk, title }: Props) => {
  const table1: FinancialTableValue[] = [
    { title: 'Total assets', key: 'totalAssets', value: risk.financialRatiosTotalAssets || 0 },
    { title: 'Total liabilities', key: 'totalLiabilities', value: risk.financialRatiosTotalLiabilities || 0 },
    { title: 'Stockholders\' equity', key: 'stockholdersEquity', value: risk.financialRatiosStockholdersEquity || 0 },
    { title: 'Net profit', key: 'netProfit', value: risk.financialRatiosNetProfit || 0 },
  ];
  const table2: FinancialTableValue[] = [
    { title: 'Debt to Asset Ratio', key: 'debtToAssetRatio', value: risk.financialRatiosDebtToAssetRatio || 0 },
    { title: 'Debt to Equity Ratio', key: 'debtToEquityRatio', value: risk.financialRatiosDebtToEquityRatio || 0 },
    { title: 'ROE', key: 'ROE', value: risk.financialRatiosROE || 0 },
    { title: 'Cash Ratio', key: 'cashRatio', value: risk.financialRatiosCashRatio || 0 },
    { title: 'DSCR', key: 'dscr', value: risk.financialRatiosDscr || 0 },
  ];

  return (
    <div className={cls.wrap}>
      <div className={cls.title}>
        {title ? title : 'Financial Ratios'}
      </div>
      <div className={cls.row}>
        <div className={cls.col}>
          <Table rows={table1} onlyMoney />
        </div>
        <div className={cls.col}>
          <Table rows={table2} />
        </div>
      </div>
    </div>
  );
};
